// Module
var code = "<div class=\"registration-wrapper\"><div class=\"ee-container finished content text-center\"><h3>Oops. We are having an issue right now. Please try again later or call Customer Support for assistance: 800.654.4432.</h3></div></div>";
// Exports
module.exports = code;